<button id="userMenuTrigger" mat-icon-button [matMenuTriggerFor]="userMenu" #userMenuTrigger="matMenuTrigger">
    <mat-icon>account_circle</mat-icon>
</button>

<mat-menu #userMenu="matMenu" [overlapTrigger]="false" class="toolbar-dropdown-menu user-menu">
    <span (mouseleave)="userMenuTrigger.closeMenu()">
        <mat-toolbar *ngIf="user">
            <div fxLayout="row" fxLayoutAlign="space-around center" class="user-info">
                <img [src]="userImage" alt="user-image" width="50" class="rounded mat-elevation-z6">
                <p>{{user.fullName}}
                    <br>
                    <small>{{user.email}}</small>
                </p>
            </div>
        </mat-toolbar>
        <button mat-menu-item (click)="router.navigateByUrl('/account')">
            <mat-icon>person</mat-icon>
            <span>Profile</span>
    </button>
    <button id="userLogout" mat-menu-item (click)="logout()">
            <mat-icon>lock</mat-icon>
            <span>Logout</span>
        </button>
    </span>
</mat-menu>
